import { useIntl } from 'react-intl';
import { Box, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import { Position } from '@xyflow/react';
import { BaseNode } from 'pages/assistants/builder/components/nodes/baseNode';

export function SwitcherNode({ id, data, handleConf, onEditNode, onDeleteNode }) {
  const ROW_HEIGHT = 40;
  const INITIAL_TOP_OFFSET = 110 + ROW_HEIGHT / 2;

  const { formatMessage: msg } = useIntl();
  const { conditions = [] } = data;

  const dynamicSourceHandles = conditions.map((conditionObj, index) => ({
    type: 'source',
    position: Position.Right,
    id: conditionObj.handleId,
    style: {
      top: `${INITIAL_TOP_OFFSET + (index - 1) * ROW_HEIGHT + (index === conditions.length ? ROW_HEIGHT / 2 : 0)}px`
    }
  }));

  return (
    <BaseNode
      id={id}
      icon="alt_route"
      nodeData={{ ...data, label: msg({ id: 'field.switcher.processor.label' }) }}
      color="error"
      handleConf={[...handleConf, ...dynamicSourceHandles]}
      key={`node-${id}`}
      onEditNode={onEditNode}
      onDeleteNode={onDeleteNode}
    >
      <Stack spacing={1.5} sx={{ p: 1, width: '500px' }}>
        <Box
          sx={{
            borderRadius: 2,
            p: 2,
            backgroundColor: '#fafafa55',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
          }}
        >
          <Stack spacing={0}>
            {conditions.map((conditionObj) => (
              <Box
                key={conditionObj.handleId}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  backgroundColor: 'white',
                  borderRadius: 1,
                  gap: 0,
                  m: 0,
                  mb: 1,
                  border: '0',
                  '&:hover': {
                    backgroundColor: '#f8f9fa',
                    borderColor: '#d0d7de'
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                {conditionObj.defaultCondition ? 'Autres cas' : conditionObj.condition}
              </Box>
            ))}
          </Stack>
        </Box>
      </Stack>
    </BaseNode>
  );
}

SwitcherNode.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.shape({
    conditions: PropTypes.arrayOf(
      PropTypes.shape({
        condition: PropTypes.string.isRequired,
        handleId: PropTypes.string.isRequired,
        order: PropTypes.number,
        defaultCondition: PropTypes.bool
      })
    ),
    handleConf: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.oneOf(['source', 'target']).isRequired,
        position: PropTypes.oneOf([Position.Top, Position.Right, Position.Bottom, Position.Left])
      })
    )
  }),
  handleConf: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['source', 'target']).isRequired,
      position: PropTypes.oneOf([Position.Top, Position.Right, Position.Bottom, Position.Left])
    })
  ),
  onEditNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired
};
